import React, { useEffect, useState } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { useDispatch, useSelector } from 'react-redux'
import { selectPreferences } from '../../../../../Redux/selectors/selectors'
import styles from './ColorsControl.module.scss'
import { setActionsOrder, setReset } from '../../../../../Redux/slices/Preferences/preferences'

function ActionsOrder() {
	const { dataNew, isReset, initialData } = useSelector(selectPreferences)
	const { actionsOrder } = dataNew.common
	const { actionsOrder: initialActionsOrder } = initialData.common
	const dispatch = useDispatch()

	function createAction(name) {
		switch (name) {
			case 'F': {
				return { name, title: 'Fold', id: `action-${name}` }
			}
			case 'C': {
				return { name, title: 'Check/Call', id: `action-${name}` }
			}
			case 'R': {
				return { name, title: 'Bet/Raise', id: `action-${name}` }
			}
			case 'A': {
				return { name, title: 'All in', id: `action-${name}` }
			}
		}
	}

	const uniqueActions = actionsOrder.map((name) => createAction(name))
	const [actionNames, setActionNames] = useState(uniqueActions)

	function handleOnDragEnd(result) {
		if (!result.destination) {
			return
		}

		const items = Array.from(actionNames)
		const [reorderedItem] = items.splice(result.source.index, 1)
		items.splice(result.destination.index, 0, reorderedItem)

		setActionNames(items)
	}

	useEffect(() => {
		const actions = actionNames.map(({ name }) => name)

		if (actions.join('') !== actionsOrder.join('')) {
			dispatch(setActionsOrder(actions))
		}
	}, [actionNames])

	useEffect(() => {
		if (isReset && actionsOrder.join('') === initialActionsOrder.join('')) {
			const uniqueActions = actionsOrder.map((name) => createAction(name))
			setActionNames(uniqueActions)
			dispatch(setReset(false))
		}
	}, [actionsOrder])

	return (
		<>
			<h3>Actions order</h3>

			<DragDropContext onDragEnd={handleOnDragEnd}>
				<Droppable droppableId='actions' direction='horizontal'>
					{(provided) => (
						<div
							className={['actions', styles.actionsContainer].join(' ')}
							{...provided.droppableProps}
							ref={provided.innerRef}
						>
							{actionNames.map(({ id, title }, index) => {
								return (
									<Draggable key={id} draggableId={id} index={index}>
										{(provided) => (
											<div
												key={id}
												ref={provided.innerRef}
												{...provided.draggableProps}
												{...provided.dragHandleProps}
												className={styles.actionItem}
											>
												{title}
											</div>
										)}
									</Draggable>
								)
							})}

							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</DragDropContext>
		</>
	)
}

export default ActionsOrder
